import { type IconProps } from './Icon.types';

const FooterContactIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width,
  height,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 19 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
        d="M15.8186 31.75H2.84947C1.35474 31.75 0.138672 30.5339 0.138672 29.0392V2.96079C0.138672 1.46605 1.35474 0.25 2.84947 0.25H15.8186C17.3133 0.25 18.5294 1.46605 18.5294 2.96079V29.0392C18.5294 30.5339 17.3133 31.75 15.8186 31.75ZM2.84948 1.33154C1.95112 1.33154 1.22022 2.06242 1.22022 2.96078V29.0392C1.22022 29.9376 1.95111 30.6685 2.84948 30.6685H15.8186C16.717 30.6685 17.4478 29.9376 17.4478 29.0392V2.96079C17.4478 2.06241 16.717 1.33155 15.8186 1.33155H2.84948V1.33154Z"
        fill={fill}/>
    <path
        d="M17.9886 5.06005H0.679443C0.380779 5.06005 0.138672 4.81794 0.138672 4.51928C0.138672 4.22063 0.380788 3.97852 0.679443 3.97852H17.9886C18.2873 3.97852 18.5294 4.22063 18.5294 4.51928C18.5294 4.81794 18.2873 5.06005 17.9886 5.06005Z"
        fill={fill}/>
    <path
        d="M17.9886 28.019H0.679443C0.380779 28.019 0.138672 27.7769 0.138672 27.4783C0.138672 27.1796 0.380788 26.9375 0.679443 26.9375H17.9886C18.2873 26.9375 18.5294 27.1796 18.5294 27.4783C18.5294 27.7769 18.2873 28.019 17.9886 28.019Z"
        fill={fill}/>
    <path
        d="M11.7569 3.19579H6.90991C6.61125 3.19579 6.36914 2.95368 6.36914 2.65503C6.36914 2.35637 6.61126 2.11426 6.90991 2.11426H11.7569C12.0556 2.11426 12.2977 2.35637 12.2977 2.65503C12.2977 2.95368 12.0556 3.19579 11.7569 3.19579Z"
        fill={fill}/>
    <path
        d="M10.555 29.8843H8.11499C7.81632 29.8843 7.57422 29.6422 7.57422 29.3435C7.57422 29.0448 7.81633 28.8027 8.11499 28.8027H10.555C10.8537 28.8027 11.0958 29.0448 11.0958 29.3435C11.0958 29.6422 10.8537 29.8843 10.555 29.8843Z"
        fill={fill}/>
    <g clipPath="url(#clip0_5881_9616)">
        <path
            d="M12.4708 18.7453C12.3891 18.6811 11.1933 17.7613 10.7251 17.4123H10.6456C11.0001 17.7164 11.7122 18.4048 11.9541 18.6241C12.2312 18.8834 12.6961 19.4724 12.4189 19.6057L12.3946 19.6142C12.0766 19.6796 11.4009 19.516 10.5264 19.1488C9.51277 18.7235 8.31807 18.0691 8.01663 17.5032C8.01663 17.5032 11.0818 15.4188 12.3228 14.4929C13.9128 13.3114 13.2857 12.3565 12.9346 12.0911C12.5006 11.7615 11.7266 11.6342 10.9316 11.6063H10.9051C10.1503 11.5874 9.39514 11.6247 8.6449 11.7178C8.4064 11.7433 6.10534 12.0438 5.89886 12.6182C5.87567 12.7043 5.86463 12.783 6.07332 13.0824C6.43199 13.5751 6.85943 14.0025 7.33978 14.3487H7.40493C6.87825 13.9064 6.56908 13.4701 6.4951 13.1975C6.48993 13.1764 6.48624 13.1549 6.48406 13.1333C6.48406 13.0278 6.50504 12.9091 6.69385 12.8436C6.88266 12.7782 7.82782 12.6776 8.805 12.7624C9.79874 12.8485 10.4866 13.0206 10.7196 13.2569C10.4204 13.4423 6.94339 15.746 5.98609 16.4658C4.74281 17.4014 5.5113 18.5672 5.84476 18.8701C6.26544 19.2543 6.87714 19.516 7.47449 19.6978H7.48112C8.04855 19.8595 8.62404 19.9849 9.20471 20.0735C9.7336 20.1692 13.0096 20.8006 13.2614 19.9329C13.4005 19.4482 12.6607 18.8919 12.4741 18.7477"
            fill={fill}/>
    </g>
    <defs>
        <clipPath id="clip0_5881_9616">
            <rect width="8.05814" height="8.7907" fill="white" transform="translate(5.29883 11.5898)"/>
        </clipPath>
    </defs>
  </svg>
);

export default FooterContactIcon;